import { render, staticRenderFns } from "./UpdateGroupInformation.vue?vue&type=template&id=7a6ef816&"
import script from "./UpdateGroupInformation.vue?vue&type=script&lang=js&"
export * from "./UpdateGroupInformation.vue?vue&type=script&lang=js&"
import style0 from "./UpdateGroupInformation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports